import { User } from "lucide-react";

import { createNavigationLucideIcon } from "./createNavigationLucideIcon";

export const CustomersIcon = createNavigationLucideIcon(User);
